import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { GuestStateStore } from './guest.state.store';
import { AuthService } from '../user/auth.service';
import { Guest, RsvpQuestion, ScheduleItem, Website, WeddingEvent } from '../website-builder/wedding';
import { Subject } from 'rxjs';
import * as en from 'date-fns/locale/en';
import { debounceTime, map, switchMap, take } from 'rxjs/operators';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { DatepickerOptions } from 'ng2-datepicker';
import { ActivatedRoute } from '@angular/router';
// import { combineLatest } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { startWith } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { RsvpComponent } from '../rsvp/rsvp.component';
import { Settings } from '../settings/settings';
import { SettingsStateStore } from '../settings/settings.state.store';
import { AngularFirestore } from 'angularfire2/firestore';
import { default as defaultWebsiteCeline } from '../website-template-celine/default-data';
import { UserService } from '../user/user.service';
import { forEach } from '@angular/router/src/utils/collection';
import { Registry } from '../registry/registry';
import { AnalyticsService } from '../analytics/analytics.service';
@Component({
  selector: 'app-guest-list',
  templateUrl: './guest-list.component.html',
  styleUrls: ['./guest-list.component.scss']
})
export class GuestListComponent implements OnInit, AfterViewInit {
  @ViewChild(RsvpComponent) rsvpComponent: RsvpComponent;

  public guestList;
  selectedGuestIsInParty = false;
  MAX_GUEST_DEAULT = 500;
  expandedParties: { [partyName: string]: boolean } = {};
  parties: { name: string, guests: Guest[] }[] = [];
  filteredGuestList: Guest[];
  currentPlusOneHost: Guest;
  currentPlusOneGuest: Guest;
  showCreateNewEvent = false;
  public currentGuest: Guest;
  tags = [];
  allGuestsSelected = false;
  secondLanguageCode: string;
  edditingAttendanceQuestion = false;
  showAddNewTag = true;
  isOptional = false;
  sampleGuests: Guest[];
  guestsToAdd: Guest[];
  guestsToUpdate: Guest[];
  guestsToUploadManual: Guest[];
  selectedTags: string[] = [];
  newTag: string;
  maxGuests = this.MAX_GUEST_DEAULT;
  showTagFormGuests = false;
  registry: Registry;
  searchTags: string[];
  guestsToAddCount = 0;
  init = false;
  settings: Settings;
  eventTotals: {
    collectRsvpsOnWebsite: boolean, eventName: string, invited: number, attending: number, declined: number, awaiting: number
  }[] = [];
  questionText = '';
  questionType = '';
  options: { id: number, value: string }[] = [];
  optionsTranslations: { id: number, value: string }[] = [];
  search = '';
  processedGuestsToUpload = false;
  systemTags: string[] = ['VIP', 'Family', 'Friends', 'Colleagues', 'Schoolmates', 'Bridesmaids', 'Groomsmen', 'Parents', 'Grandparents', 'Siblings', 'Cousins', 'Aunts', 'Uncles', 'Nieces', 'Nephews', 'In-laws', 'Godparents', 'Godchildren', 'Godsisters', 'Godbrothers', 'Goddaughters', 'Godsons', 'Maid of Honor', 'Best Man', 'Matron of Honor', 'Bridesman', 'Bridesmaid', 'Groomsman', 'Groomswoman', 'Vendor', 'Interstate', 'International'];


  times = [
  ]
  currentEvent: WeddingEvent;
  addEditEvent: WeddingEvent;
  mode = 'all'
  showAddGuestForm = false;
  editingQuestionIndex: number | null = null;
  dietaryRequirementsChanges = new Subject<{ guest: Guest, dietaryRequirements: string }>();
  showAddGuestFormBulk: boolean;
  atLeastOneSelected = false
  groupedGuests: any;
  guestNotes = new Map<Guest, Subject<string>>();
  website: Website;
  loaded: boolean;
  invitedCount: number = 0;
  acceptedCount: number = 0
  acceptedCountPercent: number = 0;
  declinedCount: number = 0;
  awaitingCount: number = 0;
  showRsvpQuestionsForm: boolean;
  questionTextTranslation: string;
  editingSecondaryLanguage: boolean;
  numberofSelectedGuests: any;

  showDropDownAddGuests: boolean;
  showDropDownExport: boolean;
  disabledSave: boolean;
  currentPosition: number;
  hideMobileMenu: boolean;
  showEndTime: boolean;
  endDateError: boolean;
  showRsvp: boolean;
  editGuestTags: boolean;
  goBackToGuestList: boolean;
  showQuestionEditingForm: boolean;
  sampleMode: boolean;
  showAddExistingGuestsModal: boolean;
  existingGuestsFromOtherEvents: Guest[];
  atLeastOneSelectedExisting: boolean;
  addingBulkGuests: boolean;
  exeededMaxGuests: boolean;
  invitedPlusOneCount: number;
  goBackToEventModal: boolean = false; selectAllExistingGuests: boolean;
  showFaqModal: boolean;
  showQuestionDataLossWarning: boolean;
  isDeleteQuestionMode: boolean;
  ;

  constructor(
    private _state: GuestStateStore,
    private _websiteStateStore: WebsiteStateStore,
    private _authService: AuthService,
    private route: ActivatedRoute,
    private _settingsStateStore: SettingsStateStore,
    private _cdr: ChangeDetectorRef,
    private firestore: AngularFirestore,
    private _analyticsService: AnalyticsService,
    private _userService: UserService
  ) {
    this.dietaryRequirementsChanges.pipe(
      debounceTime(1000),
    ).subscribe(({ guest, dietaryRequirements }) => {
      this.saveDietaryRequirements(guest, dietaryRequirements);
    });
    this.times = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        let hours = i === 0 ? 12 : (i > 12 ? i - 12 : i);
        let minutes = j < 10 ? '0' + j : j;
        let ampm = i < 12 ? 'AM' : 'PM';
        this.times.push(`${hours}:${minutes} ${ampm}`);
      }
    }
    //\ this.guestsToAdd = Array(150).fill({ firstName: '', lastName: '', partyName: '', phoneNumber: '', email: '', isPlusOneTo: '' });
  }
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('exportMenu') exportMenu: ElementRef;
  @HostListener('document:click', ['$event'])
  clickout(event) {

    if (this.showDropDownAddGuests && !this.dropdownMenu.nativeElement.contains(event.target)) {
      this.showDropDownAddGuests = false;
    }
    if (this.showDropDownAddGuests && !this.dropdownMenu.nativeElement.contains(event.target)) {
      this.showDropDownAddGuests = false;
    }
    if (this.showDropDownExport && !this.exportMenu.nativeElement.contains(event.target)) {
      this.showDropDownExport = false;
    }
    if (this.showDropDownExport && !this.exportMenu.nativeElement.contains(event.target)) {
      this.showDropDownExport = false;
    }
  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {

    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;

  }


  toggleParty(partyName: string) {
    this.expandedParties[partyName] = !this.expandedParties[partyName];
  }

  editAdanceQuestion() {
    this.edditingAttendanceQuestion = true;
    let question = this.currentEvent.attendanceQuestion
    this.questionText = question.question;
    this.showQuestionEditingForm = true;
    this.isOptional = false;
    this.questionType = question.questionType;
    this.questionTextTranslation = question.questionTranslation;
    this.options = question.options.map((option, index) => ({ id: index, value: option }));
    this.optionsTranslations = question.optionsTranslation ? question.optionsTranslation.map((option, index) => ({ id: index, value: option })) : [];
    // Ensure translations are properly synchronized when editing existing attendance questions
    this.syncOptionsTranslations();
  }
  isAnyOptionEmpty(): boolean {
    if (!this.currentEvent.attendanceQuestion || !this.currentEvent.attendanceQuestion.options) {
      return false;
    }

    return this.currentEvent.attendanceQuestion.options.some(option => !option);
  }
  ngAfterViewInit() {


    let exists = document.getElementById('intro-wiz');
    if (exists) {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
    }
  }
  checkInput(): void {

  }

  removeRsvpResponsesForDeletedEvents(guests: Guest[]) {
    if (this.website.defaultMode) {
      return;
    }
    if (!guests || !guests.length) {
      return;
    }
    if (!this.website || !this.website.weddingEvents) {
      return;
    }

    let eventIds = this.website.weddingEvents.map(event => event.id);
    for (let guest of guests) {
      for (let eventId in guest.rsvpStatus) {

        if (!eventIds.includes(eventId)) {
          delete guest.rsvpStatus[eventId];
        }
      }
    }
  }

  resetQuestionEditform() {
    this.questionText = '';
    this.questionType = '';
    this.isOptional = false;
    this.questionTextTranslation = '';
    this.options = [];
    this.optionsTranslations = [];
    this.editingQuestionIndex = null;
    this.showQuestionEditingForm = false;
  }
  addNewQuestionAndShowForm() {
    this.showQuestionEditingForm = true;

    this.questionText = '';
    this.questionType = '';
    this.questionTextTranslation = '';
    this.options = [];
    this.isOptional = false;
    this.optionsTranslations = [];
    this.editingQuestionIndex = null;

  }
  editQuestion(index: number) {
    this.showQuestionDataLossWarning = false;
    this.isDeleteQuestionMode = false;
    let question = this.currentEvent.rsvpQuestions[index];
    this.questionText = question.question;
    this.edditingAttendanceQuestion = false;
    this.questionType = question.questionType;
    this.questionTextTranslation = question.questionTranslation;
    this.options = question.options.map((option, index) => ({ id: index, value: option }));
    this.optionsTranslations = question.optionsTranslation ? question.optionsTranslation.map((option, index) => ({ id: index, value: option })) : [];
    //this.optionsTranslations = question.optionsTranslation.map((option, index) => ({ id: index, value: option }));
    //this.optionsTranslations = question.optionsTranslation.map((option, index) => ({ id: index, value: option }));
    // Ensure translations are properly synchronized when editing existing RSVP questions
    this.syncOptionsTranslations();
    this.editingQuestionIndex = index;
    this.isOptional = question.optional;
    this.showQuestionEditingForm = true;
  }
  

  deleteQuestion(index: number) {
    // Get the question ID that we're trying to delete

    // If no answers exist, proceed with deletion
    this._analyticsService.trackEvent('RSVP Question Deleted', {
      question_text: this.currentEvent.rsvpQuestions[index].question
    });
    
    this.currentEvent.rsvpQuestions.splice(index, 1);
    this.saveEvent(this.currentEvent);
    this.editingQuestionIndex = null;
    this.isDeleteQuestionMode = false;
    this.showQuestionEditingForm = false;
  }

  private hasQuestionReceviedAnswersFromGuests(questionToDelete: RsvpQuestion) {
    return this.guestList.some(guest => {
      if (!guest.rsvpResponses || !guest.rsvpResponses[questionToDelete.id]) {
        return false;
      }
      const response = guest.rsvpResponses[questionToDelete.id];
      return response !== null && response !== '';
    });
  }

  toggleLanguage(enabled: boolean) {
    this.editingSecondaryLanguage = enabled;
    // Don't clear editing state when just toggling language view
    // this.edditingAttendanceQuestion = false;
    // this.editingQuestionIndex = null;
    // this.questionText = '';
    // this.questionType = '';
    // this.questionTextTranslation = '';
    // this.options = [];
    // this.optionsTranslations = [];
    this._websiteStateStore.emitTranlation(enabled);
  }

  reviewRSVP(currentEvent: WeddingEvent) {

  }

  canBringPlusOne(guest: Guest): boolean {
    return guest.canBringPlusOne && this.guestList && !this.guestList.some(g => g.isPlusOneTo === guest.id);
  }
  toggleDropdown(event: Event) {
    event.stopImmediatePropagation();
    this.showDropDownExport = false;

    this.showDropDownAddGuests = !this.showDropDownAddGuests;
  }
  toggleDropdownExport(event: Event) {
    event.stopImmediatePropagation();
    this.showDropDownAddGuests = false;
    this.showDropDownExport = !this.showDropDownExport;
  }




  endDatePicked() {

    this.endDateError = false;

    if (this.addEditEvent.startDate && this.addEditEvent.endDate) {
      const startDateTime = new Date(this.addEditEvent.startDate);
      const endDateTime = new Date(this.addEditEvent.endDate);

      if (this.addEditEvent.startTime) {
        const startTimeParts = this.addEditEvent.startTime.match(/(\d+):(\d+) (AM|PM)/);
        let startHours = parseInt(startTimeParts[1]);
        const startMinutes = parseInt(startTimeParts[2]);
        const startPeriod = startTimeParts[3];

        if (startPeriod === 'PM' && startHours !== 12) {
          startHours += 12;
        } else if (startPeriod === 'AM' && startHours === 12) {
          startHours = 0;
        }

        startDateTime.setHours(startHours);
        startDateTime.setMinutes(startMinutes);
      }

      if (this.addEditEvent.endTime) {
        const endTimeParts = this.addEditEvent.endTime.match(/(\d+):(\d+) (AM|PM)/);
        let endHours = parseInt(endTimeParts[1]);
        const endMinutes = parseInt(endTimeParts[2]);
        const endPeriod = endTimeParts[3];

        if (endPeriod === 'PM' && endHours !== 12) {
          endHours += 12;
        } else if (endPeriod === 'AM' && endHours === 12) {
          endHours = 0;
        }

        endDateTime.setHours(endHours);
        endDateTime.setMinutes(endMinutes);
      }

      if (startDateTime && endDateTime) {
        if (startDateTime > endDateTime) {
          this.endDateError = true;
        } else if (startDateTime.getTime() === endDateTime.getTime() && this.addEditEvent.startTime && this.addEditEvent.endTime) {
          const startTimeParts = this.addEditEvent.startTime.match(/(\d+):(\d+) (AM|PM)/);
          const endTimeParts = this.addEditEvent.endTime.match(/(\d+):(\d+) (AM|PM)/);

          let startHours = parseInt(startTimeParts[1]);
          const startMinutes = parseInt(startTimeParts[2]);
          const startPeriod = startTimeParts[3];

          let endHours = parseInt(endTimeParts[1]);
          const endMinutes = parseInt(endTimeParts[2]);
          const endPeriod = endTimeParts[3];

          if (startPeriod === 'PM' && startHours !== 12) {
            startHours += 12;
          } else if (startPeriod === 'AM' && startHours === 12) {
            startHours = 0;
          }

          if (endPeriod === 'PM' && endHours !== 12) {
            endHours += 12;
          } else if (endPeriod === 'AM' && endHours === 12) {
            endHours = 0;
          }

          if (startHours > endHours || (startHours === endHours && startMinutes >= endMinutes)) {
            this.endDateError = true;
          }
        }
      }



    }
    this.addEditEvent.startDateUtc = this._websiteStateStore.preserveDateOnly(this.addEditEvent.startDate);
    if (this.addEditEvent.endDate) {
      this.addEditEvent.endDateUtc = this._websiteStateStore.preserveDateOnly(this.addEditEvent.endDate);
    } else {
      this.addEditEvent.endDateUtc = null;
    }
  }
  unInitEndTime() {
    this.showEndTime = !this.showEndTime;
    this.addEditEvent.endDate = null;
    this.addEditEvent.endTime = null;
  }
  initEndTime() {
    this.showEndTime = !this.showEndTime;
    if (this.addEditEvent.startDate) {
      this.addEditEvent.endDate = this.addEditEvent.startDate;
    }
    else {
      this.addEditEvent.endDate = new Date();
    }
  }
  initFromRoute(eventName: string, guestListMode: string) {
    let eventToEdit: WeddingEvent;
    if (this.init) {
      return;
    }

    if (eventName && this.website && this.website.weddingEvents) {
      eventToEdit = (this.website.weddingEvents.find(event => event.eventName === eventName));
      this.currentEvent = eventToEdit;

    }
    this.init = true;
    switch (guestListMode) {
      case 'add-event': {
        this.openEventForm(null);
        break;
      }
      case 'edit-event': {

        this.openEventForm(eventToEdit);
        break;
      }
      case 'add-guest': {
        this.displayAddGuestForm();
        break;

      }
      case 'bulk-upload': {
        this.showAddGuestFormBulk = true;

        break;

      }
      case 'view-event': {
        break;
      }
      case 'add-question': {
        this.editRSVPQuestions();
        break;

      } default: {

        this.currentEvent = null;
      }

    }

  }


  addTagToSearch(tag: string) {
    if (!this.searchTags) {
      this.searchTags = [];
    }
    //if tag already exists in search tags then remove it from the search tag
    if (this.searchTags.includes(tag)) {
      this.searchTags = this.searchTags.filter(t => t !== tag);
    } else {
      this.searchTags.push(tag);
    }


    this.onSearchChange()

  }
  isTagSelected(tag: string): boolean {
    if (!this.searchTags) { return false; }
    return this.searchTags.includes(tag);
  }
  removeTagToSearch(tag: string) {
    if (!this.searchTags) {
      this.searchTags = [];
    }
    this.searchTags = this.searchTags.filter(t => t !== tag);
    this.onSearchChange()
  }

  /**
   * Ensures optionsTranslations array matches options array length
   * One-way sync: options → optionsTranslations (never reverse)
   */
  private syncOptionsTranslations(): void {
    if (!this.settings || !this.settings.enableTranslations) {
      return;
    }
    
    // Ensure optionsTranslations exists
    if (!this.optionsTranslations) {
      this.optionsTranslations = [];
    }
    
    // Add missing translation entries
    while (this.optionsTranslations.length < this.options.length) {
      this.optionsTranslations.push({ 
        id: this.optionsTranslations.length + 1, 
        value: '' // Use empty string instead of placeholder text
      });
    }
    
    // Remove excess translation entries if options were deleted
    if (this.optionsTranslations.length > this.options.length) {
      this.optionsTranslations.splice(this.options.length);
    }
    
    // Update IDs to match array indices
    this.optionsTranslations.forEach((translation, index) => {
      translation.id = index + 1;
    });
  }

  addOption() {
    if (!this.options || this.options.length == 0) {
      this.options = [];
    }
    this.options.push({ id: this.options.length + 1, value: '' });
    
    // NEW: Use sync method instead of manual logic
    this.syncOptionsTranslations();
  }
  previewRsvpQeustionsAsGuest() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.rsvpComponent.godModeForEvent(this.currentEvent);
    this.showRsvpQuestionsForm = false;
  }

  onQuestionTypeChange() {
    if (this.questionType == 'multi select') {
      this.options = [];
      this.options.push({ id: 1, value: 'Option 1' });
      this.options.push({ id: 2, value: 'Option 2' });
    } else if (this.questionType == 'yes/no') {
      this.options = [];
      this.options.push({ id: 1, value: 'Yes' });
      this.options.push({ id: 2, value: 'No' });
    }
    
    // NEW: Sync translations after creating options
    this.syncOptionsTranslations();
    
    // ... rest of existing method logic remains unchanged
    if (this.editingQuestionIndex >= 0 && this.editingQuestionIndex !== null){
      let question = this.currentEvent.rsvpQuestions[this.editingQuestionIndex];
      let hasAnswers = this.hasQuestionReceviedAnswersFromGuests(question);
      if(hasAnswers){
        this.isDeleteQuestionMode = false;
        this.showQuestionDataLossWarning = true;
      }
    }
  }

  softDeleteQuestion(index: number) {
    
    this.isDeleteQuestionMode = true;
    if (index >=0 && index !== null){
      let question = this.currentEvent.rsvpQuestions[index];
      let hasAnswers = this.hasQuestionReceviedAnswersFromGuests(question);
      if (hasAnswers){
        this.showQuestionDataLossWarning = true
      } else {
        this.isDeleteQuestionMode = false;
        this.deleteQuestion(index);
      }

  
    } else {
      this.isDeleteQuestionMode = false;
      this.deleteQuestion(index);
    }
  }

  addPopularQuestion(question: string, type: string) {
    this.questionText = question;
    this.questionType = type;
    this.edditingAttendanceQuestion = false;
    this.questionTextTranslation = '';
    this.onQuestionTypeChange();
    this.addQuestion();


  }
  trackByFn(index: number, item: any): number {
    return item.id;
  }


  removeTagForGuest(guest: Guest, tag: string) {
    guest.tags = guest.tags.filter(t => t !== tag);
    this._state.updateGuest(guest);

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

  }

  setEvent(eventName: string) {

    this.currentEvent = this.website.weddingEvents.find(event => event.eventName === eventName);


  }
  addQuestion() {
    
    if(this.showQuestionDataLossWarning){
      this.showQuestionDataLossWarning = false;
    }
    let question: RsvpQuestion = {
      question: this.questionText,
      questionType: this.questionType,
      optional: this.isOptional,

      questionTranslation: this.questionTextTranslation ? this.questionTextTranslation : '',
      options: this.options.map(option => option.value),

      optionsTranslation: this.optionsTranslations ? this.optionsTranslations.map(option => option.value) : [],

      id: new Date().getTime().toString()
    };

    if (this.edditingAttendanceQuestion) {
      this.currentEvent.attendanceQuestion = question;
      this.edditingAttendanceQuestion = false;
      this._analyticsService.trackEvent('RSVP Attendance Question Edited', {
        question_text: this.questionText,
        question_type: this.questionType,
        optional: this.isOptional
      });
    } else if (this.editingQuestionIndex !== null) {
      question.id = this.currentEvent.rsvpQuestions[this.editingQuestionIndex].id;
      this.currentEvent.rsvpQuestions[this.editingQuestionIndex] = question;
      this.editingQuestionIndex = null;
      this._analyticsService.trackEvent('RSVP Question Edited', {
        question_text: this.questionText,
        question_type: this.questionType,
        optional: this.isOptional
      });
    } else {
      if (!this.currentEvent.rsvpQuestions) {
        this.currentEvent.rsvpQuestions = [];
      }
      this._analyticsService.trackEvent('RSVP Question Added', {
        question_text: this.questionText,
        question_type: this.questionType,
        optional: this.isOptional
      });
      this.currentEvent.rsvpQuestions.push(question);
    }

    this.questionText = '';
    this.questionType = '';
    this.isOptional = false;
    this.questionTextTranslation = '';
    this.options = [];

    this.saveEvent(this.currentEvent)
    this.showQuestionEditingForm = false;
  }
  onQuestionTypeChangeIndex(index: number) {
    if (this.currentEvent.rsvpQuestions[index].questionType !== 'multi select') {
      this.currentEvent.rsvpQuestions[index].options = [];
    }
  }
  editGuest(guest: Guest, openRSVPResponses: boolean = false) {
    this.currentPlusOneHost = null;
    this.currentPlusOneGuest = null;
    this.showAddGuestForm = true;
    this.currentGuest = guest;
    this.editGuestTags = false;
    if (openRSVPResponses) {
      this.showRsvp = true;
    } else {
      this.showRsvp = false;
    }

    if (guest.isPlusOneTo) {
      this.currentPlusOneHost = this.guestList.find(g => g.id === guest.isPlusOneTo);

    }

    this.currentPlusOneGuest = this.guestList.find(x => x.isPlusOneTo === guest.id);

    this.editGuestTags = false;
    this.goBackToGuestList = false;

    if (this.currentGuest && !this.currentGuest.rsvpStatus) {
      this.currentGuest.rsvpStatus = {};
    }
    if (this.currentGuest && !this.currentGuest.rsvpResponses) {
      this.currentGuest.rsvpResponses = {};
    }

  }
  isNotInvitedToAllEvents(guest): boolean {
    return this.website.weddingEvents.every(event => guest.rsvpStatus[event.id] === 'not-invited');
  }
  prefillEventformWithMoment(scheduleItem: ScheduleItem) {
    this._analyticsService.trackEvent('Event loaded Form Prefilled', {
      event_name: scheduleItem.eventName,
      start_date: scheduleItem.startDate,
      end_date: scheduleItem.endDate,
      start_time: scheduleItem.startTime,
      end_time: scheduleItem.endTime,
      venue: scheduleItem.venue,
      address: scheduleItem.address,
      attire: scheduleItem.attire,
      description: scheduleItem.description
    });

    this.addEditEvent.startDate = scheduleItem.startDate;
    this.addEditEvent.endDate = scheduleItem.endDate;
    this.addEditEvent.startTime = scheduleItem.startTime;
    this.addEditEvent.endTime = scheduleItem.endTime;
    this.addEditEvent.venue = scheduleItem.venue;
    this.addEditEvent.address = scheduleItem.address;
    this.addEditEvent.attire = scheduleItem.attire;
    this.addEditEvent.description = scheduleItem.description;
    this.addEditEvent.eventName = scheduleItem.eventName;
    if (this.addEditEvent.startDate) {
      this.addEditEvent.startDateUtc = this._websiteStateStore.preserveDateOnly(this.addEditEvent.startDate);
    }
    if (this.addEditEvent.endDate) {
      this.addEditEvent.endDateUtc = this._websiteStateStore.preserveDateOnly(this.addEditEvent.endDate);
    } else {
      this.addEditEvent.endDateUtc = null;
    }

    // if startDate is the same as End date and endtime is null then showEndTime should be false
    //also perform null checks and use gettime for comparion

    if (
      scheduleItem &&
      scheduleItem.startDate &&
      (!scheduleItem.endDate || // Check if endDate is null
        (scheduleItem.endDate && scheduleItem.startDate.getTime() === scheduleItem.endDate.getTime() &&
          (!scheduleItem.endTime || scheduleItem.endTime === "")))
    ) {
      this.showEndTime = false;
      this.addEditEvent.endDate = null;
      this.addEditEvent.endTime = null;
    } else {
      this.showEndTime = true;
    }
    if (this._cdr && !this._cdr['destroyed']) {
      this._cdr.detectChanges();
    }

  }
  isNaN(value: number): boolean {
    return isNaN(value);
  }
  questionExists(questionText: string): boolean {
    if (!this.currentEvent.rsvpQuestions) {
      return false;
    }
    return this.currentEvent.rsvpQuestions.some(question => question.question === questionText);
  }

  close() {
    const body = document.getElementsByTagName('body')[0];

    body.style.overflow = 'auto';
    this.showScrollBars();
  }

  selectAllGuests(checked: boolean) {

    this.parties.forEach(party => {
      party.guests.forEach(guest => {
        guest.selected = checked;
      });
    });
    if (checked) {
      this.atLeastOneSelected = true;
    } else {
      this.atLeastOneSelected = false;
    }
  }
  getRsvpTotals() {
    if (this.currentEvent && this.website && this.website.weddingEvents) {

      if (!this.guestList
        || this.guestList.length == 0) {
        return;
      }

      this.invitedCount = 0;
      this.acceptedCount = 0;
      this.declinedCount = 0;
      this.invitedPlusOneCount = 0;
      //

      this.guestList.forEach(guest => {
        let status = (guest.rsvpStatus && guest.rsvpStatus[this.currentEvent.id]) !== undefined ? guest.rsvpStatus[this.currentEvent.id] : null;
        switch (status) {
          case 'invited': {
            this.invitedCount++;
            if (guest.canBringPlusOne) {
              this.invitedPlusOneCount++;
            }
            break;
          }
          case 'attending':
            this.acceptedCount++;
            break;
          case 'declined':
            this.declinedCount++;
            break;
          case 'not-invited':
            // awaiting++;
            break;
        }

      });

      let totalGuests = this.invitedCount + this.acceptedCount + this.declinedCount;
      if (totalGuests > 0) {
        this.acceptedCountPercent = Math.round((this.acceptedCount / totalGuests) * 100) || 0;
      } else {
        this.acceptedCountPercent = 0;
      }
    }
  }
  filterStatus = 'all';

  filterGuests() {


    this.onSearchChange();

    this.filteredGuestList = this.filteredGuestList.filter(guest => {

      if (this.filterStatus === 'all') {
        return true;
      } else if (this.filterStatus === 'not-invited') {
        return Object.values(guest.rsvpStatus).some(status => status === null || status === 'not-invited');
      } else if (this.filterStatus === 'attending') {
        return Object.values(guest.rsvpStatus).some(status => status === 'attending');
      }
      else if (this.filterStatus === 'invited') {
        return Object.values(guest.rsvpStatus).some(status => status === 'invited');
      }
      else if (this.filterStatus === 'declined') {
        return Object.values(guest.rsvpStatus).some(status => status === 'declined');
      }
    });
    this.processParties();
  }
  toggleRsvpForEvent(event: WeddingEvent) {

    this.addEditEvent = event;
    this.saveEvent();
    this.addEditEvent = null;
  }

  deleteOption(index: number) {
    // Remove from options array
    this.options.splice(index, 1);
    
    // NEW: Sync translations after deletion
    this.syncOptionsTranslations();
  }
  objectToCSV(objArray) {
    const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}\r\n`;

    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}\r\n`;
      return str;
    }, str);
  }
  selectAllGuestsFromOtherEvents() {

    //if all existingGuestsFromOtherEvents are selected then unselect all
    if (this.existingGuestsFromOtherEvents.every(guest => guest.selected)) {
      this.existingGuestsFromOtherEvents.forEach(guest => {
        guest.selected = false;

      });
      this.selectAllExistingGuests = false;
      this.atLeastOneSelectedExisting = false;
      return;
    }

    this.existingGuestsFromOtherEvents.forEach(guest => {
      guest.selected = true;
    });
    this.atLeastOneSelectedExisting = true;
    this.selectAllExistingGuests = true;
    //  this.atLeastOneSelectedExisting = true;
  }

  closeRsvpModal() {
     this.rsvpComponent.closeRsvpModal();
    this.showRsvpQuestionsForm = true;
    
  }

  downloadCSV(csv, filename) {
    var csvFile;
    var downloadLink;

    // CSV file
    csvFile = new Blob([csv], { type: "text/csv" });

    // Download link
    downloadLink = document.createElement("a");

    if (this.currentEvent) {
      filename = `${this.currentEvent.eventName}-guest-list.csv`;

    } else if (this.search) {
      filename = 'search-results-guest-list.csv';
    } else if (!this.currentEvent) {
      filename = 'full-guest-list.csv';
    }
    // File name
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = "none";

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
  }
  exportTableToCSV(filename) {
    var csv = [];
    var headers: any = document.querySelectorAll("#guestTable thead tr th");
    var headerRow = [];
    for (var h = 0; h < headers.length; h++) {
      if (!headers[h].classList.contains('csv-ignore')) {
        let headerText = headers[h].innerText;
        headerText = headerText.replace(',', ' ');
        headerRow.push(headerText);
      }
    }
    csv.push(headerRow.join(", "));

    var rows = document.querySelectorAll("#guestTable tbody tr");

    for (var i = 1; i < rows.length; i++) {
      var row = [], cols: any = rows[i].querySelectorAll("tr > td.flex-cell");

      for (var j = 0; j < cols.length; j++) {
        let cellValue = cols[j];
        let cellText = null;
        // if(cellValue.classList.contains('exclude-from-csv')){
        //     cellText = '';
        // }
        // Skip cells with the class 'csv-ignore'
        if (cellValue.classList.contains('csv-ignore')) {
          continue;
        }
        else if (cellValue.classList.contains('tag-scroll')) {
          let tags = cellValue.querySelectorAll('label.tag span');
          ;
          let tagTexts = Array.from(tags).map(tag => {
            let tagText = (tag as any).textContent.trim();
            if (tagText != 'Add New Tag' && tagText) {
              return tagText
            }
          });
          tagTexts = tagTexts.filter(tag => tag);
          cellText = tagTexts.join('‚');
        }
        else if (cellValue.querySelector('select')) {
          cellText = cellValue.querySelector('select').value;
        }
        else if (cellValue.classList.contains('contacts')) {
          let contactData = cellValue.querySelectorAll('p.contact-csv-data');
          let contactTexts = Array.from(contactData).map(contact => `${(contact as any).textContent.trim()}`);
          cellText = contactTexts.join('‚');
        }
        else if (cellValue.classList.contains('edit-guest')) {
          let csvNameLabel = cellValue.querySelector('.csv-name');
          cellText = csvNameLabel ? csvNameLabel.innerText.trim() : '';
        }
        else if (cellValue.classList.contains('guest-notes-csv')) {
          let notesInput = cellValue.querySelector('input.guest-notes');
          cellText = notesInput ? notesInput.value : '';
        }

        else {
         
          cellText = cellValue.innerText;
                  // Sanitize the cell text for CSV
          if (cellText) {
            // Escape existing quotes first
            cellText = this.removeCommas(cellText);
          }
        }
        row.push(cellText);
      }
      csv.push(row.join(","));
    }

    // Download CSV file
    this.downloadCSV(csv.join("\n"), filename);
  }
  private removeCommas(cellText: any) {
    if (!cellText) return cellText;
    
    // Replace newlines with spaces to prevent CSV line breaks
    cellText = cellText.replace(/\r?\n/g, ' ');
    
    // Escape existing quotes
    cellText = cellText.replace(/"/g, '""');

    // If text contains commas or quotes, wrap in quotes
    if (cellText.includes(',') || cellText.includes('"')) {
      cellText = `"${cellText}"`;
    }
    return cellText;
  }

  exportTableToZzCSV(filename) {
    var csv = [];
    var rows = document.querySelectorAll("#guestTable tr");

    for (var i = 0; i < rows.length; i++) {
      var row = [], cols: any = rows[i].querySelectorAll("td, th");

      for (var j = 0; j < cols.length; j++) {

        let cellValue = cols[j];
        let cellText = null;
        let skipCell: boolean = false;
        if (cellValue.querySelector('.exclude-from-csv')) {
          skipCell = true;
        }

        else if (cellValue.querySelector('select')) {
          cellText = cellValue.querySelector('select').value;
        }
        else {
          cellText = cellValue.innerText;
        }

        row.push(cellText)

      }

      csv.push(row.join(","));
    }

    // Download CSV file
    this.downloadCSV(csv.join("\n"), 'export-guest-list.csv');
  }

  exportzzzTableToCSV() {

    let data = [];
    let headers = [];
    let table: any = document.getElementById('guestTable');
    ;
    // Get headers
    for (let i = 0; i < table.rows[0].cells.length; i++) {
      headers[i] = table.rows[0].cells[i].innerHTML.toLowerCase().replace(/ /gi, '');
    }

    // Get table data
    for (let i = 1; i < table.rows.length; i++) {
      let tableRow = table.rows[i];
      let rowData = {};

      for (let j = 0; j < tableRow.cells.length; j++) {
        rowData[headers[j]] = tableRow.cells[j].innerHTML;
      }

      data.push(rowData);
    }

    // Convert object to CSV data
    let csvData = this.objectToCSV(data);

    // Create download link and click it
    let downloadLink = document.createElement('a');
    downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvData);
    downloadLink.download = 'data.csv';
    downloadLink.click();
  }
  getGuestCountByPartyName(partyName: string): number {
    return this.guestList.filter(guest => guest.partyName === partyName).length;
  }

  setTestData() {
    if (!this.website || !this.website.weddingEvents || this.website.weddingEvents.length == 0) {
      return;
    }
    this.sampleMode = !this.settings.hasUpdatedGuestList;
    this.guestList = [];


    let sampleGuest = new Guest();
    sampleGuest.firstName = 'Ella';
    sampleGuest.lastName = 'Simmonds';
    sampleGuest.phoneNumber = '(213) 555-1234';
    sampleGuest.email = 'ella.simmonds@mail.com';

    sampleGuest.tags = ['Family']
    sampleGuest.rsvpStatus = {};

    this.website.weddingEvents.forEach(event => {
      sampleGuest.rsvpStatus[event.id] = 'attending';
    });
    sampleGuest.rsvpResponses = { 'dietary_restrictions_': 'Vegetarian', };    

    sampleGuest.id = 'sampleguest'
    sampleGuest.userId = this.website.userId;
    this.guestList.push(sampleGuest);

    return sampleGuest;

  }


  initSampleGuest(
    firstName: string,
    lastName: string,
    partyName: string,
    phoneNumber: string,
    email: string,
    isPlusOneTo: string,
    tags: string[],
    rsvpResponses: {
      [key: string]: string,

    }
   
  ) {
    if (!this.website || !this.website.weddingEvents || this.website.weddingEvents.length == 0) {
      return;
    }
    let weddingEventId = this.website.weddingEvents[0].id;
    let sampleGuest = new Guest();
    sampleGuest.firstName = firstName;
    sampleGuest.lastName = lastName;
    let randomNumber = Math.floor(Math.random() * 1000000);
    sampleGuest.partyName = partyName;
    sampleGuest.phoneNumber = phoneNumber;
    sampleGuest.email = email; 
 
    sampleGuest.tags = tags;
    sampleGuest.rsvpStatus = {};
    this.website.weddingEvents.forEach(event => {
      sampleGuest.rsvpStatus[event.id] = 'invited';
    });

    sampleGuest.rsvpResponses = rsvpResponses;
    sampleGuest.id = 'sample_' + firstName + lastName;

    return sampleGuest;
  }
  setSampleGuests() {
    let sampleGuest1 = this.initSampleGuest(
      'Amelia',
      'Scott',
      'Scott',
      '+61404488000',
      'amelia.scott@gmail.com',
      'Scott',
      ['Friends'],
      { '1': 'Yes', '2': 'No', '3': 'Maybe', 'dietary_restrictions_': 'Dairy-Free' }

    );
    let sampleGuest2 = this.initSampleGuest(
      'Zara',
      'Khan',
      'Khan',
      '+61404488000',
      'zkhan@gmail.com',
      'Khan',
      ['Colleagues'],
      { '1': 'Yes', '2': 'No', '3': 'Maybe', 'dietary_restrictions_': '—' }

    );
    let sampleGuest3 = this.initSampleGuest(
      'Julian',
      'Costa',
      'Costa',
      '+61404488000',
      'julian.costa@gmail.com',
      'Costa',
      ['Colleagues'],
      { '1': 'Yes', '2': 'No', '3': 'Maybe', 'dietary_restrictions_': 'Gluten-Free' }

    );
    let sampleGuest4 = this.initSampleGuest(
      'Noah',
      'Sanders',
      'Sanders',
      '+61404488000',
      'noah.sanders@mail.com',
      'Sanders',
      ['In-laws'],
      { '1': 'Yes', '2': 'No', '3': 'Maybe', 'dietary_restrictions_': 'Vegan' }

    );
    let sampleGuest5 = this.initSampleGuest(
      'Clara',
      'Bennett',
      'Bennett',
      '+61404488000',
      'clara.bennett@gmail.com',
      'Bennett',
      ['Interstate'],
      { '1': 'Yes', '2': 'No', '3': 'Maybe', 'dietary_restrictions_': '—' }
    );

    this.sampleGuests = [sampleGuest1, sampleGuest2, sampleGuest3, sampleGuest4, sampleGuest5];

  }
  getSelectedGuestsCount(): number {
    if (!this.existingGuestsFromOtherEvents) {
      return 0;
    }
    return this.existingGuestsFromOtherEvents.filter(guest => guest && guest.selected).length;
  }

  removeFromEvent() {
    let guestsToRemove = this.guestList.filter(guest => guest.selected);
    guestsToRemove.forEach(guest => {
      guest.rsvpStatus[this.currentEvent.id] = 'not-invited';
      this._state.updateGuest(guest);
    });
    this._analyticsService.trackEvent('Guests Removed', {
      guests: guestsToRemove.map(guest => guest.firstName)
    });
    this.bulkUpdate(guestsToRemove)
    this.atLeastOneSelected = false;
  }
  checkIfSelectedExisting() {
    this.atLeastOneSelectedExisting = this.existingGuestsFromOtherEvents.some(guest => guest.selected);


  }
  addExistingGuestToEvent() {




    let guestsToAddToEvent = this.existingGuestsFromOtherEvents.filter(guest => guest.selected);
    guestsToAddToEvent.forEach(guest => {
      guest.rsvpStatus[this.currentEvent.id] = 'invited';
      this._state.updateGuest(guest);
      this._analyticsService.trackEvent('Guest Added', {
        guest_name: guest.firstName,
        event_name: this.currentEvent.eventName,
        from: 'existing guests'
      });

    });
    this.bulkUpdate(guestsToAddToEvent)
    this.showAddExistingGuestsModal = false;
    this.processParties();

    this.showScrollBars();

  }
  resetExistingSelectedGuests() {
    this.existingGuestsFromOtherEvents.forEach(guest => guest.selected = false);
    this.atLeastOneSelectedExisting = false;

  }

  showExistingGuestModal() {
    this._analyticsService.trackEvent('Show Existing Guests Modal', {});
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.showAddExistingGuestsModal = true;
    this.existingGuestsFromOtherEvents = this.guestList.filter(guest => guest.rsvpStatus && guest.rsvpStatus[this.currentEvent.id] == 'not-invited');
    //ensure all guests are selected=false
    this.existingGuestsFromOtherEvents.forEach(guest => guest.selected = false);

  }

  ngOnInit() {
    document.title = 'Hitchd | Guest List';

    this.website = this.route.snapshot.data.website;

    this.registry = this.route.snapshot.data.registry;
    this.guestList = this.route.snapshot.data.guests;
    this.settings = this.route.snapshot.data.settings;



    //Refactor the defaultWebsiteCeline to come from the websiteStateStore    this.website = this.websiteStateStore.getWebsite();

    // Check for essential website properties, not just any keys
    const hasEssentialProps = this.website &&
      Object.keys(this.website).length > 1 && // More than just tags
      this.website.hasOwnProperty('welcome') // Or any other essential property
      && this.website.hasOwnProperty('story')
      && this.website.hasOwnProperty('registry');

    if (((!this.website || Object.keys(this.website).length === 0) && this.settings) || (this.website && !hasEssentialProps)) {

      this.website = defaultWebsiteCeline;
      this._websiteStateStore.updateWebsiteWithSetupData(this.website, this.registry);

    }

    this._settingsStateStore.getState().subscribe(state => {
      this.settings = state.settings;
      if (this.settings && this.settings.secondLanguage) {
        this.secondLanguageCode = this._websiteStateStore.getLanguageCode(this.settings.secondLanguage);
      }
      this.initSampleData();
      if (this.settings && this.settings.maxGuests) {
        this.maxGuests = this.settings.maxGuests;
      } else {
        this.maxGuests = this.MAX_GUEST_DEAULT;
      }
    });
    this._state.getState().subscribe(state => {



      if (state.guests && state.guests.length > 0) {
        this.guestList = state.guests;

        if (this.settings) {
          this.sampleMode = !this.settings.hasUpdatedGuestList;
        }
        this.removeRsvpResponsesForDeletedEvents(this.guestList);
        this.initializeRsvpStatus();

        if (this.search || (this.searchTags && this.searchTags.length > 0) || this.filterStatus !== 'all') {
          this.onSearchChange();
        } else {

          this.filterEvent(this.currentEvent);
          this.processParties()
        }

        if (this.addingBulkGuests) {
          this.addingBulkGuests = false;
          this.showAddGuestForm = false;
          this.showAddGuestFormBulk = false;
          this.guestsToAdd = [];
          this.guestsToUpdate = [];

        }


      } else if (this.parties && this.parties.length && state.guests.length == 0) {



        this.guestList = [];
        this.parties = [];
        this._cdr.detectChanges();
        this.loaded = true;

      }
      else {
        this.loaded = true;

        this.initSampleData();
      }
    });


    this._websiteStateStore.getState().subscribe(state => {
      if (state && state.website && Object.keys(state.website).length >= 1) {
        this.website = state.website;

        this.initSampleData();
        this.removeRsvpResponsesForDeletedEvents(this.guestList);

        if (this.website !== undefined && this.website.weddingEvents && this.website.weddingEvents.length > 0) {
          const event$ = this.route.params.pipe(map(params => params['event']));
          const guestListMode$ = this.route.data.pipe(map(data => data['guestListMode']));
          combineLatest(event$, guestListMode$).take(1).subscribe(([event1, guestListMode]) => {
            this.initFromRoute(event1, guestListMode);
          });

        }
        console.log(this.website.weddingEvents)
        //if this.currentEvent is not null then get it again from the update website.weddingEvents where the id is the same as teh currentEventid

        if (this.currentEvent) {
          this.currentEvent = this.website.weddingEvents.find(event => event.id === this.currentEvent.id);

          this.filterEvent(this.currentEvent);
        }

        this.initializeRsvpStatus();
        if (!this.currentEvent) {
          this.setDefaultCurrentEvent();
        }


        this.initTags(state.website);

      }
    });

  }

  initSampleData() {
    this.setSampleGuests();
    if (this.settings && !this.settings.hasUpdatedGuestList) {
      this.setTestData();
    }
  }
  addTag() {
    if (this.website && !this.website.tags) {
      this.website.tags = [];
    }
    let newTagToAdd = this.newTag.trim();
    this.showAddNewTag = true;
    this.website.tags.push(newTagToAdd);
    this.newTag = null;
    this._analyticsService.trackEvent('Tag Added', {
      tag: newTagToAdd
    });
    this.selectedTags.push(newTagToAdd);
    this._websiteStateStore.updateWebsite(this.website);
  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  toggleTagForGuest(tag: string, guest: Guest) {
    if (!guest.tags) {
      guest.tags = [];
    }
    this._analyticsService.trackEvent('Guest Tag Added', {
      guest_name: guest.firstName,
      tag: tag
    });
    const index = guest.tags.indexOf(tag);
    if (index < 0) {
      guest.tags.unshift(tag);
    } else {
      guest.tags.splice(index, 1);

    }

    this._cdr.detectChanges();

    if (guest && guest.id) {
      this._state.updateGuest(guest);
    }

  }


  openFaqModal() {
    this.showFaqModal = true;
    this._analyticsService.trackEvent('Guest List- Help FAQ Modal Opened', {});
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }

  closeFaqModal() {
    this.showFaqModal = false;
    this._analyticsService.trackEvent('Guest List- Help FAQ Modal Closed', {});
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }

  toggleTag(tag: string) {

    const index = this.selectedTags.indexOf(tag);
    if (index < 0) {
      this.selectedTags.unshift(tag);
    } else {
      this.selectedTags.splice(index, 1);
      this.selectedTags.unshift(tag);
    }
  }
  initTags(website: Website) {
    // Only initialize tags if we have a valid website object
    if (website && Object.keys(website).length > 1) { // > 1 because we want more than just tags
      if (!website.tags) {
        website.tags = [];
      }
      this.tags = website.tags.concat(this.systemTags);
    }
  }

  addTagsForGuest(guest: Guest) {

    this.showAddGuestForm = true;
    this.currentGuest = guest;
    this.editGuest(guest);
    this.editGuestTags = true;
    this.goBackToGuestList = true;
    this._analyticsService.trackEvent('Guest Tags Added', {
      guest_name: guest.firstName,
      tags: guest.tags
    });

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';



  }
  setQuestionType(questionType: string) {
    this.questionType = questionType;
    if (this.questionType === 'multi select') {
      this.options = [{ id: 1, value: '' }];
    }
  }
  initializeRsvpStatus() {

    if (!this.website || !this.website.weddingEvents || this.website.weddingEvents.length === 0) {
      return;
    }
    if (!this.guestList) {
      return;

    }

    this.website.weddingEvents.forEach(event => {
      this.guestList.forEach(guest => {

        if (!guest.rsvpStatus) {
          guest.rsvpStatus = {};
        }

        if (!guest.rsvpStatus[event.id]) {
          guest.rsvpStatus[event.id] = "not-invited";
        }
      });
    });
  }
  setDefaultCurrentEvent() {

    if (this.website && this.website.weddingEvents && this.website.weddingEvents.length > 1) {
      this.currentEvent = null;
      this.getRsvpTotals();
    } else if (this.website && this.website.weddingEvents && this.website.weddingEvents.length === 1) {
      this.currentEvent = this.website.weddingEvents[0];
      this.filterEvent(this.currentEvent)

    }

  }

  processList() {
    this.guestsToAddCount = 0;
    for (let guest of this.guestsToAdd) {
      // You can modify this part to include the properties you need

      if (guest.firstName || guest.lastName || guest.phoneNumber || guest.email) {
        this.guestsToAddCount = this.guestsToAddCount + 1
      }



    }


    // Now guestsList contains the list of guests to add
    // You can use it here as needed
  }
  setRsvpStatus(guest: Guest, eventId: string, status: string) {
    this._analyticsService.trackEvent('RSVP Status Set', {
      guest_name: guest.firstName,
      event_id: eventId,
      status: status
    });
    if (!guest.rsvpStatus) {
      guest.rsvpStatus = {};
    }
    guest.rsvpStatus[eventId] = status;
    this._state.updateGuest(guest);

    if (this.allGuestsSelected) {
      this.allGuestsSelected = false;
    }

    // const selectedGuests = this.guestList.filter(guest => guest.selected);
    // if (selectedGuests.length == 0) {
    //   guest.rsvpStatus[eventId] = status;
    //   this._state.updateGuest(guest);
    // }
    // else {
    //   selectedGuests.forEach(guest => {
    //     guest.rsvpStatus[eventId] = status;
    //     guest.selected = false;
    //   });

    //   this.bulkUpdate(selectedGuests);

    // }

    this.getRsvpTotals();
  }

  bulkUpdate(guests: Guest[]) {
    this._state.bulkUpdateGuests(guests);
    this.atLeastOneSelected = false;
  }

  getGuestsWhoOnlyHaveInviteStatusForEventButAreNotInvitedToAnyOtherEvent(eventId: string): Guest[] {
    return this.guestList.filter(guest => {
      return guest.rsvpStatus[eventId] != 'not-invited' && this.website.weddingEvents.every(event => {
        return event.id === eventId || guest.rsvpStatus[event.id] === 'not-invited';
      });
    });
  }

  deleteEvent(event: WeddingEvent) {
    this.website.weddingEvents = this.website.weddingEvents.filter(e => e.id !== event.id);

    this._analyticsService.trackEvent('Event Deleted', {
      event_name: event.eventName
    });

    let guests = this.getGuestsWhoOnlyHaveInviteStatusForEventButAreNotInvitedToAnyOtherEvent(event.id);

    this._state.bulkDeleteGuests(guests);
    this._websiteStateStore.updateWebsite(this.website);
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

    this.showCreateNewEvent = false;
    this.setDefaultCurrentEvent();
    this.processParties();
  }
  saveEvent(event: WeddingEvent = null) {

    // Use addEditEvent if no event is provided
    event = event || this.addEditEvent;

    // Initialize weddingEvents if it's not already an array
    this.website.weddingEvents = this.website.weddingEvents || [];

    if (event.id) {
      this.updateExistingEvent(event);
      this.filterEvent(event);
      this._websiteStateStore.updateWebsite(this.website);
    } else {
      let eventAdded = this.addNewEvent(event);
      this.currentEvent = eventAdded;
      this._websiteStateStore.updateWebsite(this.website);
      this.currentEvent = eventAdded;
      this.filterEvent(eventAdded);

    }




    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';

    this.showCreateNewEvent = false;

  }

  updateExistingEvent(event: WeddingEvent) {
    const index = this.website.weddingEvents.findIndex(e => e.id === event.id);

    if (index !== -1) {
      // Replace the existing event
      this.website.weddingEvents[index] = event;
    } else {
      // Add the event to the array
      this.website.weddingEvents.push(event);
    }
  }

  addNewEvent(event: WeddingEvent) {

    event.rsvpQuestions = event.rsvpQuestions || null;
    event.id = new Date().getTime().toString();
    this.filteredGuestList = null;
    this.parties = [];
    event.attendanceQuestion = new RsvpQuestion();
    event.attendanceQuestion.question = "Will you be attending?";
    event.attendanceQuestion.questionType = "multi select";
    event.attendanceQuestion.options = ["Yes", "No"];

    event.attendanceQuestion.optionsTranslation = ["", ""];
    this.website.weddingEvents.push(event);
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

    return event;


  }

  shouldFilterEvent(event: WeddingEvent) {
    return this.showCreateNewEvent && (!this.currentEvent || this.currentEvent.id !== event.id);
  }


  dateOptions: DatepickerOptions = {
    minYear: 2018,
    maxYear: 2025,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date',
    //  placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    //  addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  filterEvent(event: WeddingEvent) {


    if (!event) {
      this.filteredGuestList = this.guestList;
      this.currentEvent = null;
    } else {
      this.currentEvent = event;


      if (!this.guestList || this.guestList.length == 0) {
        return;

      }

      this.filteredGuestList = this.guestList.filter(x =>

        x.rsvpStatus[event.id] &&
        x.rsvpStatus[event.id] != 'not-invited'

      )
    }

    this.getRsvpTotals()

    this.processParties();
  }
  closeAddGiftModal() {
    this.showCreateNewEvent = false
    const body = document.getElementsByTagName('body')[0];

    body.style.overflow = 'auto';
    ;
  }
  getTimeValuesFromTimeString(timeString: string) {

    const timeParts = timeString.match(/(\d+):(\d+)/);
    let hours = parseInt(timeParts[1]);
    const minutes = parseInt(timeParts[2]);

    let period = 'AM';
    if (hours >= 12) {
      period = 'PM';
      if (hours > 12) {
        hours -= 12;
      }
    } else if (hours === 0) {
      hours = 12;
    }

    return {
      hours,
      minutes,
      period
    }

  }
  getStartDateFromEventDate(): Date {
    if (this.website.welcome.eventDate) {
      return new Date(this.website.welcome.eventDate);
    } else if (this.website.weddingEvents && this.website.weddingEvents.length > 0) {
      return new Date(this.website.weddingEvents[0].startDate);
    }
  }
  closeQuestionsModal() {

    if (this.goBackToEventModal) {
      this.showCreateNewEvent = true;
      this.goBackToEventModal = false;
    }
    this.showRsvpQuestionsForm = false;
    this.close();

  }
  editRSVPQuestions(hideEventModal = false) {
    if (hideEventModal) {
      this.showCreateNewEvent = false;
      this.goBackToEventModal = true;
    } else {
      this.goBackToEventModal = false;
    }

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    if (this.currentEvent && !this.currentEvent.rsvpQuestions) {
      this.currentEvent.rsvpQuestions = [];

    }
    this.showRsvpQuestionsForm = true;
    this.showQuestionDataLossWarning = false;
    this.isDeleteQuestionMode = false;
    this.showQuestionEditingForm = false;
    this.edditingAttendanceQuestion = false;
    this.questionText = null;
    this.isOptional = false;
    this.questionTextTranslation = null;
    this.questionType = null;
  }
  openEventForm(event: WeddingEvent) {
    this.showCreateNewEvent = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.showEndTime = false;
    if (!event) {
      this.addEditEvent = new WeddingEvent();
      this.addEditEvent.startDate = this.getStartDateFromEventDate();


      this.addEditEvent.collectRsvpsOnWebsite = true;
    } else {
      this.addEditEvent = event;
      if (this.addEditEvent.endDate || this.addEditEvent.endTime) {
        this.showEndTime = true;
      }


    }


  }
  emitNotes(guest: Guest, notes: string) {
    let subject = this.guestNotes.get(guest);
    if (!subject) {
      subject = new Subject<string>();
      subject.pipe(debounceTime(2000)).subscribe(notes => {
        guest.notes = notes;
        this._state.updateGuest(guest);
      });
      this.guestNotes.set(guest, subject);
    }
    subject.next(notes);
  }
  removeFromParty() {
    const selectedGuests = this.guestList.filter(guest => guest.selected);
    selectedGuests.forEach(guest => {
      guest.partyName = null;
      guest.selected = false;
    });
    this.bulkUpdate(selectedGuests);
    this.guestList = [...this.guestList];
    this.processParties();
    this.selectedGuestIsInParty = false;
  }
  processParties() {
    // Reset parties array


    if (!this.guestList || this.guestList.length == 0) {
      this.loaded = true;
      return;
    }

    this.parties = [];

    let guestsToProcess = this.guestList;
    if (this.filteredGuestList && this.filteredGuestList.length > 0) {
      guestsToProcess = this.filteredGuestList;
    } else if (this.filteredGuestList && this.filteredGuestList.length === 0) {
      guestsToProcess = [];
    }
    // Group guests by party name
    const groupedGuests = guestsToProcess.reduce((groups, guest) => {
      const key = guest.partyName || `No Party ${guest.id}`; // Unique key for guests with no party
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(guest);
      return groups;
    }, {});

    //foreach party, find any guests that are a plus one to another guest, and reorder them so that the plusone guest is after the main guest



    for (const partyName in groupedGuests) {
      let party = groupedGuests[partyName];
      let plusOnes = party.filter(guest => guest.isPlusOneTo);

      let mainGuests = party.filter(guest => !guest.isPlusOneTo);


      let reorderedParty = mainGuests;
      plusOnes.forEach(plusOne => {
        let mainGuest = mainGuests.find(guest => guest.id === plusOne.isPlusOneTo);
        if (mainGuest) {
          reorderedParty.splice(reorderedParty.indexOf(mainGuest) + 1, 0, plusOne);
        }
      });
      if (reorderedParty && reorderedParty.length > 0) {
        groupedGuests[partyName] = reorderedParty;
      } else {
        groupedGuests[partyName] = groupedGuests[partyName];
      }
    }

    // Convert grouped guests to parties array
    for (const partyName in groupedGuests) {
      this.parties.push({
        name: partyName,
        guests: groupedGuests[partyName]
      });
    }

    //sort groupedGuests by created date desc
    this.parties.sort((a, b) => {
      return new Date(b.guests[0].createdDate).getTime() - new Date(a.guests[0].createdDate).getTime();
    });

    this.loaded = true;
  }
  updateGuest() {
    this._state.updateGuest(this.currentGuest);
    this.showAddGuestForm = false;
    this.showScrollBars();
  }

  addGuest() {
    if (this.currentEvent) {
      if (!this.currentGuest.rsvpStatus) {
        this.currentGuest.rsvpStatus = {};
      }

      this.currentGuest.rsvpStatus[this.currentEvent.id] = 'invited';
    }
    this._analyticsService.trackEvent('Guest Added', {
      first_name: this.currentGuest.firstName,
      event_name: this.currentEvent ? this.currentEvent.eventName : 'No Event'
    });
    this._state.addGuest(this.currentGuest);
    this.showAddGuestForm = false;
    this.showScrollBars();
  }
  updateSelectedStatus(guest: Guest = null) {

    // guest.selected = !guest.selected;
    if (guest && guest.partyName) {
      this.selectedGuestIsInParty = true;
    }
    this.atLeastOneSelected = this.guestList.some(guest => guest.selected);
    this.numberofSelectedGuests = this.guestList.filter(guest => guest.selected).length;
  }
  searchTag(tag: string) {
    this.search = tag;
    this.onSearchChange();

  }

  // onSearchChange() {

  //   if (this.search || this.mode == 'all') {
  //     this.filteredGuestList = this.guestList.filter(guest =>
  //       (guest.firstName && guest.firstName.toLowerCase().includes(this.search.toLowerCase())) ||
  //       (guest.lastName && guest.lastName.toLowerCase().includes(this.search.toLowerCase())) ||
  //       (guest.email && guest.email.toLowerCase().includes(this.search.toLowerCase())) ||
  //       (guest.phoneNumber && guest.phoneNumber.includes(this.search)) ||
  //       (guest.tags && guest.tags.includes(this.search))
  //     );
  //   } else {
  //     // If there's no search term and mode is not 'all', reset the filtered list to show all guests
  //     this.filteredGuestList = null;
  //   }
  //   this.processParties();
  // }

  onSearchChange() {



    if (this.mode != 'all') {
      this.filterGuests();
    } else {
      this.filteredGuestList = this.guestList;
    }


    if (this.searchTags && this.searchTags.length > 0) {
      this.filteredGuestList =
        this.guestList.filter(guest =>
          (this.searchTags && this.searchTags.some(tag => guest.tags && guest.tags.includes(tag))));
    } else {
      this.filteredGuestList = this.guestList;
    }

    if (this.search) {


      this.filteredGuestList = this.filteredGuestList.filter(guest =>


      (
        (guest.firstName && guest.firstName.toLowerCase().includes(this.search.toLowerCase())) ||
        (guest.lastName && guest.lastName.toLowerCase().includes(this.search.toLowerCase())) ||
        (guest.email && guest.email.toLowerCase().includes(this.search.toLowerCase())) ||
        (guest.phoneNumber && guest.phoneNumber.includes(this.search))
      )

      );
    }
    this.processParties();
  }

  // get partyNames(): string[] {
  //   return Array.from(new Set(this.guestList.filter(guest => guest.partyName).map(guest => guest.partyName)));
  // }
  get partyNames(): string[] {
    const partyNames = this.guestList.map(guest => guest.partyName);
    let uniquePartyNames = partyNames.filter((value, index, self) =>
      typeof value === 'string' && self.indexOf(value) === index
    );
    uniquePartyNames = uniquePartyNames.filter(partyName => partyName !== '');
    return uniquePartyNames;
  }

  getGuestsByPartyName(partyName: string): Guest[] {
    return this.guestList.filter(guest => guest.partyName === partyName);
  }
  enableWeddingWebsite() {
    this.settings.completedGuestListOnboarding = true;
    this._analyticsService.trackEvent('Guest List Onboarding Completed', {});
    if (this.website && this.website.isLive == undefined) {
      this.website.isLive = false;
    }
    this._websiteStateStore.updateWebsite(this.website);

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.saveSettings()
  }
  saveSettings() {
    this._settingsStateStore.updateSettings(this.settings);
  }
  onGuestSelectionChange() {
    this.updateSelectedStatus();
  }

  createParty() {

    const selectedGuests = this.guestList.filter(guest => guest.selected);
    let partyId = selectedGuests[0].id;
    selectedGuests.forEach(guest => {
      guest.partyName = partyId;
      guest.selected = false;
    })

    this.bulkUpdate(selectedGuests);
    this.guestList = [...this.guestList];
    this.processParties();
    this.atLeastOneSelected = false;
    // Handle selected guests
    this._analyticsService.trackEvent('Guest Party Created', {
      party_id: partyId,
      guests: selectedGuests.map(guest => guest.firstName)
    });
    this.allGuestsSelected = false;
  }
  deleteSelected() {
    const selectedGuests = this.guestList.filter(guest => guest.selected);
    this.guestList = this.guestList.filter(guest => !guest.selected);



    if (selectedGuests.length == 1) {
      if (selectedGuests[0].id == 'sampleguest') {
        this.guestList = this.guestList.filter(guest => guest.id != 'sampleguest');

        this._state.reviewSettings();
        this.atLeastOneSelected = false;
        this.allGuestsSelected = false;
        this.parties = [];
        return;
      }
    }

    this._analyticsService.trackEvent('Guests Deleted', {
      guests: selectedGuests.map(guest => guest.firstName)
    });

    this._state.bulkDeleteGuests(selectedGuests);
    this.atLeastOneSelected = false;
    // Handle selected guests
    this.allGuestsSelected = false;

  }

  addGuestBulk() {

    if (this.currentEvent) {
      this.guestsToAdd.forEach(guest => {
        if (!guest.rsvpStatus) {
          guest.rsvpStatus = {};
        }
        guest.rsvpStatus[this.currentEvent.id] = 'invited';
      });


    }
    this.addingBulkGuests = true;
    this._analyticsService.trackEvent('Guests Bulk Added', {
      guests: this.guestsToAdd.map(guest => guest.firstName)
    });
    this._state.bulkAddGuests(this.guestsToAdd).then(() => {
      this.showScrollBars();

    });

    // this._state.updateGuestsBulk(this.guestsToUpdate)

  }
  updateGuestUpload(event: any, index: number, field: string) {
    // If the guest doesn't exist in the array, create it
    if (!this.guestsToAdd[index]) {
      this.guestsToAdd[index] = null;
    }

    if (!this.guestsToUploadManual) {
      this.guestsToUploadManual = [];
    }
    if (!this.guestsToUploadManual[index]) {
      this.guestsToUploadManual[index] = null
    }

    this.guestsToUploadManual[index][field] = event.target.innerText;
    // Update the field
    this.guestsToUploadManual[index][field] = event.target.innerText;
  }
  resetGuestUpload() {
    this.guestsToAdd = [];
    // this.guestsToAdd = Array(150).fill({ firstName: '', lastName: '', partyName: '', phoneNumber: '', email: '', isPlusOneTo: '' });
    this.guestsToUploadManual = [];

  }
  handlePaste(event: ClipboardEvent, rowIndex: number) {
    // Prevent the default paste action
    event.preventDefault();
    this._analyticsService.trackEvent('Guests Bulk CSV Pasted', {});
    this.exeededMaxGuests = false;

    if (!event || !event.clipboardData) {
      return;
    }

    // Get the pasted data as text
    const pastedText = event.clipboardData.getData('text');

    if (!pastedText) {
      return;
    }

    // Split the pasted text into rows and columns
    const rows = pastedText.split('\n');

    if (!rows) {
      return;
    }

    this.guestsToAdd = [];
    this.processedGuestsToUpload = true;
    let rsvpStatus = {};
    if (this.currentEvent) {
      rsvpStatus[this.currentEvent.id] = 'invited';
    }

    rows.forEach((row, i) => {
      const columns = row.split('\t');

      // Skip header row - check for common header variations
      const firstCol = columns[0] && columns[0].toLowerCase().trim();
      if (firstCol && (
        firstCol === 'first name' ||
        firstCol === 'first name (required)' ||
        firstCol === 'firstname' ||
        firstCol.includes('first') ||
        firstCol.includes('name')
      )) {
        return;
      }

      // Check if row has any non-empty values
      const hasData = columns.some(cell => cell && cell.trim().length > 0);
      if (!hasData) {
        return;
      }

      // Check for existing guest
      if (this.guestList && this.guestList.length > 0) {
        let existingGuest = this.guestList.find(guest =>
          guest.firstName === columns[0] && guest.lastName === columns[1]
        );

        if (existingGuest) {
          if (this.currentEvent) {
            if (!existingGuest.rsvpStatus) {
              existingGuest.rsvpStatus = rsvpStatus;
            } else {
              existingGuest.rsvpStatus[this.currentEvent.id] = 'invited';
            }
          }
          return; // Skip adding existing guest
        }
      }

      // Add new guest with null checks
      const firstName = columns[0] && columns[0].trim() || '';
      const lastName = columns[1] && columns[1].trim() || '';
      const phoneNumber = columns[2] && columns[2].trim() || '';
      const email = columns[3] && columns[3].trim() || '';

      this.guestsToAdd.push({
        firstName,
        lastName,
        notes: "",
        rsvpStatus: rsvpStatus,
        phoneNumber,
        email,
        isPlusOneTo: null,
        partyName: null,
        rsvpResponses: {},
        createdDate: new Date().getTime(),
        modifiedDate: new Date().getTime(),
        userId: null,
        dietaryRequirements: '',
        id: null,
        isChild: false,
        tags: [],
        selected: false,
        canBringPlusOne: false,
        plusOneFirstName: '',
        plusOneLastName: ''
      });
    });

    const existingGuestListLength = this.guestList && this.guestList.length || 0;
    this.exeededMaxGuests = existingGuestListLength + this.guestsToAdd.length > this.maxGuests;
  }



  addTags() {
    this.showTagFormGuests = true;
    this.initTags(this.website);
    this.selectedTags = [];


    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';

  }
  applyTags() {
    const selectedGuests = this.guestList.filter(guest => guest.selected);

    this._analyticsService.trackEvent('Tags Applied', {
      tags: this.selectedTags
    });
    if (selectedGuests.length == 0 && this.currentGuest) {
      selectedGuests.push(this.currentGuest);
    }

    selectedGuests.forEach(guest => {

      if (!guest.tags) {
        guest.tags = [...this.selectedTags];
      } else {
        guest.tags = [...this.selectedTags, ...guest.tags];
      }

      guest.selected = false;

    });
    this.bulkUpdate(selectedGuests);
    this.showTagFormGuests = false;
    this.selectedTags = [];
    this.allGuestsSelected = false;

    this.editGuestTags = false;
  }

  hideScroll() {

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }

  showScrollBars() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }

  displayAddGuestForm() {
    this._analyticsService.trackEvent('Add Guest Form Displayed', {});
    if (this.guestList && this.guestList.length > this.maxGuests) {
      return;
    }
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
    this.currentGuest = new Guest();
    this.showRsvp = false;
    this.showAddGuestForm = true;
  }

  displayBulkUploadForm() {
    this._analyticsService.trackEvent('Bulk Upload Form Displayed', {});
    if (this.guestList && this.guestList.length >= this.maxGuests) {
      return;
    }
    this.showAddGuestFormBulk = true;
    this.hideScroll()
  }

  handleFileInput(files: FileList) {
    const file = files.item(0);
    const reader = new FileReader();
    reader.onload = (event) => {
      const csv = (event.target as FileReader).result;
      this.processCsv(csv as string);
    };
    reader.readAsText(file);
  }
  isSelected(tag: string) {
    return this.selectedTags.includes(tag);
  }
  isSelectedForGuest(tag: string, guest: Guest) {
    if (!guest.tags) {
      return false;
    }
    return guest.tags.includes(tag);
  }
  processCsv(csv: string) {
    // Process the CSV data
  }

  onDietaryRequirementsChange(guest: Guest, dietaryRequirements: string) {
    this.dietaryRequirementsChanges.next({ guest, dietaryRequirements });
  }

  saveDietaryRequirements(guest: Guest, dietaryRequirements: string) {
    // Save the changes
    guest.dietaryRequirements = dietaryRequirements;
    this._state.updateGuest(guest);
  }
}


// WEBPACK FOOTER //
// ./src/app/guest-list/guest-list.component.ts